import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Portal } from 'react-portal';

import TaskTooltipContent from './task_tooltip_content';
import {
  TASK_TOOLTIP_CLASS_NAME as CLASSNAME,
  TASK_TOOLTIP_HORIZONTAL_POSITIONS,
  TASK_TOOLTIP_VERTICAL_POSITIONS,
} from './constants';

const taskTooltipId = 'task-dropdown-tooltip';

const TaskTooltip = ({
  children,
  containerHeight,
  containerWidth,
  displayTooltipInPortal,
  isOpen,
  paddingHorizontalRemoval,
  paddingVerticalRemoval,
  taskComponent,
  taskRef,
}) => {
  const portalElement = _.invoke(document, 'getElementById', taskTooltipId);

  const tooltip = (
    <TaskTooltipContent
      containerHeight={containerHeight}
      containerWidth={containerWidth}
      displayTooltipInPortal={displayTooltipInPortal}
      isOpen={isOpen}
      paddingHorizontalRemoval={paddingHorizontalRemoval}
      paddingVerticalRemoval={paddingVerticalRemoval}
      taskComponent={taskComponent}
      taskRef={taskRef}
    />
  );
  return (
    <div className={CLASSNAME}>
      {children}
      {!displayTooltipInPortal && tooltip}

      {displayTooltipInPortal && <Portal node={portalElement}>{tooltip}</Portal>}
    </div>
  );
};

TaskTooltip.propTypes = {
  children: PropTypes.shape({}),
  containerHeight: PropTypes.number,
  containerWidth: PropTypes.number,
  displayTooltipInPortal: PropTypes.bool,
  isOpen: PropTypes.bool,
  paddingHorizontalRemoval: PropTypes.number,
  paddingVerticalRemoval: PropTypes.number,
  positionHorizontal: PropTypes.oneOf(_.values(TASK_TOOLTIP_HORIZONTAL_POSITIONS)), // eslint-disable-line react/no-unused-prop-types
  positionVertical: PropTypes.oneOf(_.values(TASK_TOOLTIP_VERTICAL_POSITIONS)), // eslint-disable-line react/no-unused-prop-types
  taskComponent: PropTypes.shape({
    comments: PropTypes.number,
    issues: PropTypes.number,
    name: PropTypes.string,
    task_status: PropTypes.shape({
      code: PropTypes.string,
      name: PropTypes.string,
    }),
  }),
  taskRef: PropTypes.shape({
    current: PropTypes.shape({}),
  }),
};

TaskTooltip.defaultProps = {
  paddingHorizontalRemoval: 0,
  paddingVerticalRemoval: 0,
  positionHorizontal: 'left',
  positionVertical: 'bottom',
};

export default TaskTooltip;
